var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"all"}},[_c('van-icon',{staticClass:"icon",attrs:{"size":"30","color":"rgba(255,255,255,0.6)","name":"arrow-left"},on:{"click":_vm.toHome}}),_c('div',[_vm._v(_vm._s(_vm.title))]),_c('img',{attrs:{"src":require("@/assets/img/details/sx.png"),"alt":""},on:{"click":function($event){return _vm.$emit('filtrate')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }